import gql from 'graphql-tag'

export const GET_PRESET_GROUP_LIST = gql`
  query GetPresetGroups {
    presetGroups(orderBy: order_ASC) {
      id
      name
    }
  }
`

export const GET_PRESET_GROUP_BY_ID = gql`
  query GetPresetGroupById($id: Int!) {
    presetGroup(id: $id) {
      id
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/PresetGroup.js